export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('RatingStars', ({ rating, maxRating, size }) => {
        const newId = Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);

        const sizeClass = {
          small: 'scale(.5)',
          medium: 'scale(.75)',
          large: 'scale(1)',
        }[size ?? 'medium'];

        const translatingClass = {
          small: 'translate(-80px , -24px)',
          medium: 'translate(-160px ,-32px)',
          large: '',
        }[size ?? 'medium'];

        return {
          percent: `${isNaN((rating * 100) / maxRating) ? 0 : (rating * 100) / maxRating}%`,

          paintPercent() {
            const targetContainer = document.getElementById(
              'percent_stars_placeholder',
            );
            targetContainer.setAttribute('id', `percent_stars_${newId}`);
            targetContainer.style.background = `linear-gradient(to right, #FFBD4C, #FFBD4C ${this.percent}, #e6e6e6 ${this.percent}, #e6e6e6 100%)`;

            const targetStarsContainer = document.getElementById(
              'container-stars-placeholder',
            );
            targetStarsContainer.setAttribute('id', `container-stars-${newId}`);
            targetStarsContainer.style.transform = `${sizeClass} ${translatingClass}`;
          },
        };
      });
    });
  },
};
